import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    alignItems: 'center',
    color: theme.new.color.brandPrimary,
    display: 'flex',
    gap: theme.new.spacing.xsmall,
    textDecoration: 'none',
    '& svg': {
      height: '12px',
      width: '12px',
    },
  },
}));

export default useStyles;
